import type {
    InstagramInitialData
} from "../../navigation/type";

let currentDraft: InstagramInitialData | null = null;

const setInstagramDraft = (draft: InstagramInitialData | null) => {
    currentDraft = draft;
};

const getInstagramDraft = (): InstagramInitialData | null => {
    return currentDraft;
};

export {
    setInstagramDraft,
    getInstagramDraft
};
